/**
 * Lecture du statut du rapprochement remonté par le simulateur.
 *
 * POURQUOI CE FICHIER EXISTE. Le 25 août 2026, un run a déposé 67 remorques et
 * n'en a consolidé que 26. L'écran affichait « terminé », sans un mot. La
 * consolidation se faisait tuer au CPU à chaque tentative, et personne ne lisait
 * le code de retour. Le défaut n'était pas d'échouer — c'était d'échouer en
 * silence.
 *
 * La règle est donc explicite et testée plutôt que dispersée dans le JSX : deux
 * états sont sains, l'absence de statut n'est pas un échec, tout le reste doit
 * se voir.
 */

/** Accepté et poursuivi en arrière-plan. Mode NORMAL depuis le passage en 202. */
export const RAPPROCHEMENT_DECLENCHE = 'déclenché';

/** Terminé de façon synchrone. N'arrive qu'avec `?attendre=1`. */
export const RAPPROCHEMENT_OK = 'ok';

/**
 * Un statut absent signifie qu'aucun rapprochement n'a encore eu lieu — normal
 * au début d'un run. Le confondre avec un échec ferait crier au loup à chaque
 * démarrage, et l'alerte cesserait d'être lue.
 */
export function rapprochementEnEchec(statut: string | null | undefined): boolean {
  if (statut === null || statut === undefined || statut === '') return false;
  return statut !== RAPPROCHEMENT_OK && statut !== RAPPROCHEMENT_DECLENCHE;
}

/** Libellé affiché, y compris quand rien n'a encore eu lieu. */
export function libelleRapprochement(statut: string | null | undefined): string {
  if (statut === null || statut === undefined || statut === '') return 'pas encore déclenché';
  return statut;
}
